import { getAllQuizzes  } from './data/quiz/actions';

export const loadManagerComponent = (store) => {
    return store.dispatch(getAllQuizzes(), );
};

export const mok = (store) => {
    return true;
};